import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Tabs from '../components/ui/Tabs';
import GeneralInfoForm from '../components/forms/GeneralInfoForm';
import '../styles/EmployeeMaster.css';
import ModalityTable from '../components/ModalityTable';

const Modality = () => {
  const [employees, setEmployees] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/modality/add';

  const handleAddClick = () => {
    
    navigate('/modality/add');
  };

  const handleCloseModal = () => {
    navigate('/modality');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Modality Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Modality
        </button>
      </div>

      <ModalityTable />
    </div>
  );
};

export default Modality;